// LazySizes config
window.lazySizesConfig = window.lazySizesConfig || {};
window.lazySizesConfig.loadMode = 1;

// requestIdleCallback polyfill
window.requestIdleCallback = window.requestIdleCallback || function (cb) {
  return setTimeout(function () {
    const start = Date.now();
    cb({
      didTimeout: false,
      timeRemaining: function () {
        return Math.max(0, 50 - (Date.now() - start));
      }
    });
  }, 1);
};

// Preconnect fallback (вдруг не сработал из <head>)
(function() {
  var link = document.createElement('link');
  link.rel = 'preconnect';
  link.href = 'https://cdn.shopify.com';
  link.crossOrigin = 'anonymous';
  document.head.appendChild(link);
})();
